import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./TerminalHeader.css";

export const TerminalHeader = () => {
    const location = useLocation();

    const isActive = (path) => {
        if (path === "/" && location.pathname === "/") return true;
        if (
            path === "/posts" &&
            (location.pathname === "/posts" ||
                location.pathname.startsWith("/posts/"))
        )
            return true;
        return false;
    };

    return (
        <header className="terminal-header">
            <div className="ascii-logo">
                {/* idk why this needs to be unindented*/}
                <Link to="/">
                    <pre>{`
███╗   ███╗██╗   ██╗███████╗████████╗ █████╗ ██████╗ ██████╗ ████████╗██╗ ██████╗ ███████╗██████╗
 ████╗ ████║██║   ██║██╔════╝╚══██╔══╝██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██║██╔════╝ ██╔════╝██╔══██╗
 ██╔████╔██║██║   ██║███████╗   ██║   ███████║██████╔╝██║  ██║   ██║   ██║██║  ███╗█████╗  ██████╔╝
 ██║╚██╔╝██║██║   ██║╚════██║   ██║   ██╔══██║██╔══██╗██║  ██║   ██║   ██║██║   ██║██╔══╝  ██╔══██╗
 ██║ ╚═╝ ██║╚██████╔╝███████║   ██║   ██║  ██║██║  ██║██████╔╝   ██║   ██║╚██████╔╝███████╗██║  ██║
 ╚═╝     ╚═╝ ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝    ╚═╝   ╚═╝ ╚═════╝ ╚══════╝╚═╝  ╚═╝
        `}</pre>
                </Link>
            </div>
            <nav className="terminal-nav">
                <span className="nav-prompt">$</span>
                <Link to="/" className={isActive("/") ? "active" : ""}>
                    about
                </Link>
                <span className="nav-separator">::</span>
                <Link
                    to="/posts"
                    className={isActive("/posts") ? "active" : ""}
                >
                    posts
                </Link>
                {/* <span className="cursor"></span>*/}
            </nav>
        </header>
    );
};
